import { get } from "lodash";

// import { verify } from "crypto";
// import { add } from "lodash";

// import { getOutOfStockProductList } from ".";

// export const base_url = "https://adminuat.easylife.progfeel.co.in/";
// export const base_url = "http://192.168.9.210:8000/";
// export const base_url = "https://admin.easylife.progfeel.co.in";
// export const base_url = "https://prod1.sajilolife.com/";
export const base_url = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
// export const base_url = "/"

// export const order_apis ={
//     search_past_order: (currentPage) => `api/v0/orders/search-order/?page=${currentPage}`,

// }



export const login_apis = {
  login: "api/v0/auth/login/",
  verify_otp: "api/v0/auth/otp/",
};

export const category_apis = {
  categories: `api/v0/dashboard/main-categories/`,
  sub_categories: (category_id) =>
    `api/v0/dashboard/subcategory/${category_id}/`,
};

export const shop_apis = {
  nearest_shops: `api/v0/dashboard/category/store_list/`,
};

export const product_apis = {
  home_product_list: (page, limit) =>
    `api/v0/product/home_product_list/?page=${page}&limit=${limit}`,
  search_products: (isSearch) =>
    `api/v0/dashboard/search/products/?is_search=${isSearch}`,
  add_product: `api/v0/product/add/`,
  update_product: (product_id) =>
    `api/v0/product/update_product/${product_id}/`,
  product_details: (product_id) =>
    `api/v0/product/product_deatils/${product_id}/`,
  single_product_details: (identifier) =>
    `api/v0/product/product_deatils/${identifier}/`,
  getOutOfStockProductList: () => `api/v0/product/check-zero-product/?all=true`,
  product_delete: (product_id) =>
    `api/v0/product/product_delete/${product_id}/`,
  store_product_lists: (storeId) =>
    `api/v0/store/store_product_list/${storeId}/`,
  sort_store_product_lists: (storeId, sortValue) =>
    `api/v0/store/store_product_list/${storeId}/?sort_value=${sortValue}`,
  add_bulk_upload_products: `api/v1/store/product/bulk_upload/`,
  master_product: `api/v0/product/master-product/`,
  brought_together: `api/v0/product/top_pics_products/`,
  unit_of_measure: `api/v0/product/unit-of-measures/list/`,
  product_ratings: (id) => `api/v0/product/product_rating/${id}/`,
  product_detail_ratings: (id) => `api/v0/product/product-rating/${id}/`,
  user_product_ratings: (id) => `api/v0/product/product-rating/${id}/`,
  store_ratings: (currentPage, limit) =>
    `api/v0/product/order-store-details/?page=${currentPage}&limit=${limit}`,
  last_viewed_products: `api/v0/product/last-viewed-products/`,
  // Buy again products
  // 1900 to below order contains
  // store with products
  store_product_details: (storeId, currentPage, prodStatus) =>
    `api/v0/store/store_product_list/${storeId}/?page=${currentPage}&prod_status=${prodStatus}`,
  search_products_in_store: (currentPage) =>
    `api/v0/store/search_product/${currentPage ? `?page=${currentPage}` : `?all=${true}`
    }`,
  search_store_product_suggestions: () => `api/v0/store/search_product/`,
  add_product: () => "api/v0/product/add/",
  edit_product: (productId) => `api/v0/product/update_product/${productId}/`,
  product_for_review: (currentPage, limit) =>
    `api/v0/product/order-product-details/?page=${currentPage}&limit=${limit}`,
  last_viewed: () => `api/v0/product/last-viewed-products/`,
};

export const deals_apis = {
  top_deals: `api/v0/offer/top-picks/`,
  top_deals_suggestions: `api/v0/offer/top-picks/`,
};

export const notifications_apis = {
  get_notifications: `api/v0/auth/user/notification/list/`,
  get_all_notifications: `api/v0/auth/user/notification/list/`,
  mark_notification_as_read: (notificationId) =>
    `api/v0/auth/user/notification/details/${notificationId}/`,
  click_bell_icon: `api/v0/auth/user/notification/bell/click/`
};

export const contact_apis = {
  enquiry: `api/v0/auth/contact-us/`,
};

export const email_verify_apis = {
  verify_email: (userId) => `api/v0/auth/user/${userId}/verify-email/`,
  otp_to_verify_email: (userId) =>
    `api/v0/auth/user/${userId}/email-verification/`,
};

export const wishlist_apis = {
  add_to_wishlist: `api/v0/orders/wishlist/`,
  view_wishlist: `api/v0/orders/wishlist/`,
  delete_wishlist: `api/v0/orders/wishlist/`,
};

export const addresses_apis = {
  saved_address: `api/v0/auth/user/addresses/`,
  add_address: `api/v0/auth/user/addresses/`,
  delete_address: (id) => `api/v0/auth/user/address-modify/${id}/`,
  edit_address: (addressId) => `api/v0/auth/user/address-modify/${addressId}/`,
};

export const user_apis = {
  edit_user_details: (userId) => `api/v0/auth/user/profile/`,
  get_user_details: () => `api/v0/auth/user/profile/`,
  verify_email: (userId) => `api/v0/auth/user/${userId}/verify-email/`,
  otp_to_verify_email: (userId) =>
    `api/v0/auth/user/${userId}/email-verification/`,
  saved_address: () => "api/v0/auth/user/addresses/",
  add_address: () => "api/v0/auth/user/addresses/",
  delete_address: (id) => `api/v0/auth/user/address-modify/${id}/`,
  edit_address: (addressId) => `api/v0/auth/user/address-modify/${addressId}/`,
  user_profile_delete: () => `api/v0/auth/user/profile/delete/`,
  submit_contact_enquiry: () => "api/v0/contact/message/enquiry/",
};

export const miscellaneous_api = {
  languages: () => "api/v0/language/language_list",
  all_subcategories: () => "api/v0/dashboard/subcategory/0/",
  subcategories: () => "api/v1/dashboard/sub_category/list/",
};

export const order_apis = {
  add_to_cart: () => `api/v0/orders/add_to_cart/`,
  update_cart: () => `api/v0/orders/add_to_cart/`,
  remove_from_cart: () => "api/v0/orders/add_to_cart/",
  view_cart: () => `api/v1/orders/cart/`,
  cart_order_id: () => `api/v0/cart/cart-order-id/`,
  apply_coupon: () => "api/v0/product/cart/",

  cod_payment: () => `api/v0/orders/cart/`,

  order_list: () => `api/v1/store/order_list/`,
  sort_order_list: (sortValue) =>
    `api/v0/store/order_list/?sort_value=${sortValue}`,
  past_orders: (currentPage) =>
    `api/v0/orders/order_summery/?page=${currentPage}`,

  view_past_orders: (id) => `api/v2/orders/order/${id}/`,
  cancel_order: () => `api/v0/orders/cancel-order/`,
  get_product_availability: () => `api/v0/orders/stock/available/`,

  fetch_cancellation_reasons: () => `api/v0/orders/user/cancel/line_item/`,
  fetch_order_cancellation_reasons: () =>
    `api/v0/orders/user/cancel/line_item/`,
  cancel_line_item: () => `api/v0/orders/user/cancel/line_item/`,
  fetch_seller_cancellation_reasons: () =>
    `api/v0/orders/seller/cancel/line_item/`,
  seller_cancel_line_item: () => `api/v0/orders/seller/cancel/line_item/`,

  // Recommendations & Reorder
  buy_again_products: () => "api/v0/orders/buy/again/products/",
};

export const store_apis = {
  search_stores: (isSearch) =>
    `api/v0/dashboard/search/stores/?is_search=${isSearch}`,
  store_registration: () => "api/v0/store/stores/create/",
  store_bank_details: () => "api/v0/store/stores/bank-details/",
  store_subcategory_view: (storeId, page, limit) =>
    `api/v0/store/product_list/${storeId}/category/?page=${page}&limit=${limit}`,
  setStore: (storeId) => `api/v0/store/stores/details/${storeId}/`,
  updateStore: (storeId) => `api/v0/store/stores/${storeId}/`,
  my_store: () => "api/v0/store/stores/my_stores/",
  create_offers: () => "api/v0/offer/store-offers/",
  edit_offer: (id) => `api/v0/offer/offer-modify/${id}/`,
  offer_list: () => "api/v0/offer/store-offers/",
  store_offer: () => "api/v0/offer/store-offers/",
  get_offer_details: (offerID) => `api/v0/offer/offer-modify/${offerID}/`,
  store_revenue: () => "api/v0/store/store-revenue/",
  today_offers: () => `api/v0/offer/today-store-offers/`,
  coupons: () => `api/v0/offer/platform-offers/`,
  get_bank_details: () => `api/v0/store/stores/bank-details/`,
  get_store_ratings: (id) => `api/v0/store/store-rating/${id}/`,
  selected_store_ratings: (id) => `api/v0/store/store-rating/${id}/`,
  user_store_ratings: (id) => `api/v0/store/store-rating/${id}/`,
  get_store_account_statement: () => `api/v0/store/seller/account/statement/`,
  get_store_account_statement_pdf: () =>
    `api/v0/store/seller/account/statement/`,
  get_store_account_dashboard: () => `api/v0/store/seller/earnings/dashboard/`,
  get_store_transaction_data: () =>
    `api/v0/store/seller/account/transaction/data/`,
  store_reviews: (storeId) => `api/v0/store/store-rating/${storeId}/`,
  dashboard_summary: "api/v1/store/dashboard-summary/"
};


export const brand_apis = {
  get_brand_categories: `api/v1/brand-categories/`,
  get_brands: `api/v1/approved-brands/`,
  request_new_brand: `api/v1/brand-request/create/`,
}

export const delivery_apis = {
  partners: () => `api/v2/delivery/partners/`,
  store_preference: () => `api/v2/delivery/store-preference/`,
  sync_store: () => `api/v2/delivery/store-preference/sync/`,
  merchant_dashboard: (page = 1, pageSize = 20, status = "", dateRange = "") => {
    let url = `api/v2/delivery/merchant-dashboard/?page=${page}&page_size=${pageSize}`;
    if (status && status !== "ALL") url += `&status=${encodeURIComponent(status)}`;
    if (dateRange && dateRange !== "ALL") url += `&date_range=${encodeURIComponent(dateRange)}`;
    return url;
  },
  stats: (dateRange = "") => {
    let url = `api/v2/delivery/stats/`;
    if (dateRange && dateRange !== "ALL") url += `?date_range=${encodeURIComponent(dateRange)}`;
    return url;
  },
  settlement_summary: () => `api/v2/delivery/settlement/summary/`,
  settlement_ledger: (page = 1, pageSize = 20, eventType = "") => {
    let url = `api/v2/delivery/settlement/ledger/?page=${page}&page_size=${pageSize}`;
    if (eventType && eventType !== "ALL") url += `&event_type=${encodeURIComponent(eventType)}`;
    return url;
  },
  order_status: (id) => `api/v2/delivery/orders/${id}/status/`,
  retry_order_sync: (id) => `api/v2/delivery/orders/${id}/retry/`,
  serviceability: () => `api/v2/delivery/serviceability/`,
  checkout_shipping: () => `api/v2/delivery/checkout-shipping/`,
};

export const custom_domain_apis = {
  create: "api/v1/custom-domains/add/",
  detail: (domainId) => `api/v1/custom-domains/${domainId}/`,
  list: "api/v1/custom-domains/list/",
  verify: (domainId) => `api/v1/custom-domains/${domainId}/verify/`,
  retry: (domainId) => `api/v1/custom-domains/${domainId}/retry/`,
  delete: (domainId) => `api/v1/custom-domains/${domainId}/remove/`,
  resolve: "api/v1/custom-domains/resolve/",
};

export const store_carousel_apis = {
  create: "/api/v1/store/carousels/",
  list: "/api/v1/store/carousels/",
  detail: (storeCarouselId) => `/api/v1/store/carousels/${storeCarouselId}/`,
  delete: (storeCarouselId) => `/api/v1/store/carousels/${storeCarouselId}/`,
  update: (storeCarouselId) => `/api/v1/store/carousels/${storeCarouselId}/`,
  reorder: "/api/v1/store/carousels/reorder/",
};